module.exports = __webpack_public_path__ + "img/lineup_comm_bg.312941b0.png";